// extracted by mini-css-extract-plugin
export default {"link":"ArrowCircleLink_link__HxV0j","icon":"ArrowCircleLink_icon__+3J8y","left":"ArrowCircleLink_left__qGMxN","right":"ArrowCircleLink_right__izy8X"};